import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { isAuthorized } from "../../shared/settings/auth";

const AdminRoute = ({ component: Component, children, ...rest }) => {

    const loggedInUserData = useSelector((state) => state.user);
    const userRole = loggedInUserData?.role || loggedInUserData?.user_type || loggedInUserData?.type || loggedInUserData?.userRole;

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthorized() && userRole === "admin" ? (
                    Component ? <Component {...props} /> : children
                ) : (
                    <Redirect to="/home" />
                )
            }
        />
    );
};

export default AdminRoute;
